import React from 'react';
import JobList from './JobList';
import StudiesList from './StudiesList';
import SkillList from './SkillList';

import './AboutMe.css';

const AboutMe = () => {
  return (
    <div>
      <div className="block paddingTop">
        <JobList />
      </div>
      <div className="block backGrey paddingTop" >
        <StudiesList />
      </div>
      <div className="block paddingTop" >
        <SkillList />
      </div>
    </div> 
  )
}

export default AboutMe;